export default __webpack_public_path__ + "static/media/sponsor_logo_mx.7f3a16bd.svg";